namespace Client.InfrastructureTypes

open Elmish

[<RequireQualifiedAccess>]
module Cmds =
    let batch (additionalCmd: Cmd<'cmd>) (model: 'model, cmd: Cmd<'cmd>) = model, Cmd.batch [ cmd; additionalCmd ]